import { createFileRoute } from "@tanstack/react-router";
import PassSignIn from "../../views/signin/PassSignIn";

export const Route = createFileRoute("/signin/")({
  component: PassSignIn,
});
